import * as React from 'react';
import { SVGProps } from 'react';

const FileIconCsvSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 19h6v2.5H9V19Zm-1 3.5V18h18v15H8V22.5Zm17-1V19h-4v2.5h4Zm-4 1h4V25h-4v-2.5Zm-1-1V19h-4v2.5h4Zm-4 1h4V25h-4v-2.5Zm-1 0V25H9v-2.5h6Zm5 9.5h-4v-2.5h4V32Zm-5 0v-2.5H9V32h6Zm5-3.5h-4V26h4v2.5Zm-5 0V26H9v2.5h6Zm10 0V26h-4v2.5h4Zm-4 1h4V32h-4v-2.5Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7 12c-.587 0-1.017-.123-1.29-.37-.273-.253-.41-.663-.41-1.23V8.6c0-.56.137-.967.41-1.22.28-.253.71-.38 1.29-.38h1.29v1h-1.25c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h1.25v1H12.7ZM19 7h1v3h1V7h1v3l-1 2h-1l-1-2V7Zm-1.39 4.69c.26-.207.39-.52.39-.94v-.45c0-.427-.117-.747-.35-.96-.233-.22-.573-.34-1.02-.34h-.15a.544.544 0 0 1-.35-.1c-.087-.073-.13-.187-.13-.34v-.11c0-.147.05-.257.15-.33.1-.08.233-.12.4-.12H18V7h-1.5c-.493 0-.907.1-1.16.3-.253.193-.34.513-.34.96v.47c0 .44.073.763.3.97.233.2.433.3.9.3h.37c.287 0 .43.15.43.45v.1c0 .147-.047.26-.14.34-.093.073-.23.11-.41.11H15v1h1.5c.487 0 .857-.103 1.11-.31Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconCsvSizeM;
